export const productCardDefectModalName = 'product-card-defect';
